import { createStore } from 'vuex'

export default createStore({
  state: {
    colecciones: [
      {
        idCol: 1,
        codCol: 'GesLibros',
        shoCol: 'ShowLibros',
        nomCol: 'Libros'
      },
      {
        idCol: 2,
        codCol: 'GesPubPer',
        shoCol: 'ShowPubPer',
        nomCol: 'Publicaciones periódicas'
      },
      {
        idCol: 3,
        codCol: 'GesMemorias',
        shoCol: 'ShowCongPonen',
        nomCol: 'Memorias de congresos'
      },
      {
        idCol: 4,
        codCol: 'GesTesisY',
        shoCol: 'ShowTesisY',
        nomCol: 'Tesis, seminarios, trabajos e informes'
      },
      {
        idCol: 5,
        codCol: 'GesHemero',
        shoCol: 'ShowHemeros',
        nomCol: 'Hemerografías'
      },
      {
        idCol: 6,
        codCol: 'GesSeparatas',
        shoCol: 'ShowSeparatas',
        nomCol: 'Separatas'
      },
      {
        idCol: 7,
        codCol: 'GesSellos',
        shoCol: 'ShowSellos',
        nomCol: 'Sellos'
      },
      {
        idCol: 8,
        codCol: 'GesPostales',
        shoCol: 'ShowPostales',
        nomCol: 'Postales'
      },
      {
        idCol: 9,
        codCol: 'GesMiscel',
        shoCol: 'ShowMiscel',
        nomCol: 'Misceláneos'
      }
    ],
    // { idCol: 6, codCol: 'GesSeparatas', nomCol: 'Separatas' },
    ColEnGestion: '',
    usuarioEnSesion: {}
  },
  mutations: {
    SetColEnGestion (state, coleccion) {
      state.ColEnGestion = coleccion.idCol
    },
    doLogin (state, usuario) {
      state.usuarioEnSesion = usuario
      // console.log(usuario) // -----------------------
    },
    doLogout (state) {
      state.usuarioEnSesion = {}
    }
  },
  actions: {
    GetColEnGestion ({ commit }, coleccion) {
      commit('SetColEnGestion', coleccion)
    },
    doLogin ({ commit }, usuario) {
      commit('doLogin', usuario)
    },
    doLogout ({ commit }) {
      commit('doLogut')
    }
  },
  modules: {
  }
})
